<template>
  <article>
    <AppBanner title-alignment="text-left flex-row">
      <template #bannerTitle>
        <div>
          <h1 class="mb-2">
            <template v-if="loading">
              Loading...
            </template>

            <template v-else-if="event">
              {{ event.name }}
            </template>
          </h1>

          <AppLink
            :to="{ name:'app_admin_event_list' }"
            class="underline text-secondary font-semibold"
          >
            Back to all events
          </AppLink>
        </div>
      </template>

      <div class="flex items-center gap-3">
        <AppLink
          :to="{ name: 'app_event_show' }"
          class="underline text-secondary font-semibold"
        >
          View event
        </AppLink>

        <AppLink :to="{ name: 'app_admin_event_edit' }">
          <AppButton
            type="button"
            class="btn-solid btn-secondary rounded-sm px-3 md:px-5 whitespace-nowrap"
          >
            <FontAwesomeIcon :icon="faPenToSquare" />
            Edit Event
          </AppButton>
        </AppLink>
      </div>
    </AppBanner>

    <AppContainer class="mb-12">
      <AdminTabs />

      <RouterView v-slot="{ Component }">
        <KeepAlive>
          <component :is="Component" />
        </KeepAlive>
      </RouterView>
    </AppContainer>
  </article>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { computed, onMounted, provide, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useHead } from '@vueuse/head';

import { AppBanner, AppButton, AppContainer, AppLink } from '@/components/app';
import { AdminTabs } from '@/components/app/admin';

import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { useHttp } from '@/composables';

const route = useRoute();
const router = useRouter();

const loading = ref(true);
const event = ref({});
const pageTitle = computed(() => event.value ? event.value.name : '');
const ogImageUrl = computed(() => event.value ? event.value.eventImage : '');

provide('event', event);
provide('event.loading', loading);

const loadEvent = async () => {
  const response = await useHttp().get(`/events/${route.params.slug}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    event.value = response.data;
  }

  loading.value = false;
};

useHead({
  title: pageTitle,
  meta: [
    {
      property: 'og:title',
      content: pageTitle,
    },
    {
      property: 'og:image',
      content: ogImageUrl,
    },
    {
      name: 'twitter:title',
      content: pageTitle,
    },
    {
      name: 'twitter:image',
      content: ogImageUrl,
    },
  ],
});

onMounted(() => {
  if (route.name === 'app_admin_event_show') {
    router.replace({ name: 'app_admin_event_show_overview' });
  }
});

loadEvent();

</script>
